import { render } from "./CadastroParametros.vue?vue&type=template&id=1edad296"
import script from "./CadastroParametros.vue?vue&type=script&lang=js"
export * from "./CadastroParametros.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__